import common from './common'
import str from './str'
import date from './date'
import media from './media'
import num from './num'
import arr from './arr'
import obj from './obj'
import uri from './uri'
import site from './site'
import form from './form'

export default {
  common,
  str,
  date,
  media,
  num,
  arr,
  obj,
  uri,
  site,
  form,
}
